export default __webpack_public_path__ + "static/media/steps.6fa576f2.svg";